import { motion } from "motion/react";
import Typewriter from "./Typewriter";
import { useContext, useRef, useState } from "react";
import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import cx from "classnames";
import { BUN_PUBLIC_IMAGE_BASE_URL } from "@/env.json";

export default function AnimatedIntro({ containerRef }: { containerRef?: React.RefObject<HTMLDivElement> | undefined }) {
  const [typewriterSpeed, setTypewriterSpeed] = useState(30);
  const [typewriterDelay, setTypewriterDelay] = useState(1);
  const [showName, setShowname] = useState(false);
  const scrollYProgress = useContext(ScrollAnimContext);

  // Refs for measuring widths
  const heroRef = useRef<HTMLDivElement>(null);

  return (
    <motion.div
      className='mx-auto flex flex-col-reverse md:flex-row font-semibold text-start justify-between w-full text-3xl/snug lg:text-4xl/snug xl:text-5xl/snug gap-y-16'
      ref={heroRef}
    >
      <div className='flex flex-col gap-y-6 lg:gap-y-8 justify-center grow'>
        <Typewriter
          delay={typewriterDelay}
          speed={typewriterSpeed}
          cursor={!(scrollYProgress.get() > 0.45)}
          onUpdate={(isComplete = false) => setTimeout(() => setShowname(isComplete), 500)}
        >
          Hello there, nice to meet you 👋
        </Typewriter>
        <div className={cx("w-full transition-opacity duration-1000 ease-in-out", { "opacity-0": !showName })}>
          <h2>My name's Xavier</h2>
        </div>
      </div>
      <div
        className='aspect-square rounded-full h-[50svw] sm:h-[40svw] md:h-[30svw] xl:h-[20svw] 2xl:h-[15svw] w-fit mx-auto'
        style={{
          backgroundImage: `url(${BUN_PUBLIC_IMAGE_BASE_URL}/portrait.jpg)`,
          backgroundSize: "cover",
        }}
      />
    </motion.div>
  );
}
